import { render, staticRenderFns } from "./BrandSupportOverview.vue?vue&type=template&id=d08c4fd6"
import script from "./BrandSupportOverview.vue?vue&type=script&lang=js"
export * from "./BrandSupportOverview.vue?vue&type=script&lang=js"
import style0 from "./BrandSupportOverview.vue?vue&type=style&index=0&id=d08c4fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports